import React, { Component } from "react";
import TRTC from 'trtc-js-sdk';
import VideoHeader from "components/videoHeader";
import VideoFooter from "components/videoFooter";
import VideoModel from "components/videoModel";
import { unparam, agoraClient } from "utils/common";
//主体中的图片
import videoHome from "images/video-home.png";
import videoPending from "images/video-jiazai.png";
import videoPassed from "images/video-true.png";
import videoFailed from "images/video-false.png";
import startRecord from "images/start-record.png";
//样式文件
import "./index.less";
// 国际化
import i18nZh_cn from "utils/zh_cn";
import i18nEn_us from "utils/en_us";

class App extends Component{
    state = {
        visible: false,
        accountId: "",
        //检测状态: pending => 检测中， passed => 检测通过， failed => 检测失败
        browser: "pending",
        network: "pending",
        audio: "pending",
        video: "pending",
        checkAllPassed: false
    }
    componentDidMount() {
        //获取页面参数
        const queryString = unparam(location.search);
        // 国际化
        const lang = queryString.lang ? queryString.lang.toLocaleLowerCase() : "zh_cn";
        const i18n = lang === "en_us" ? i18nEn_us : i18nZh_cn;
        this.setState({
            accountId: queryString.accountId,
            i18n,
            lang
        })
        document.title = i18n.pageTitle.check;
        //各项检测
        setTimeout(() => {
            this.detectBrowser();
            this.detectNetwork();
            this.detectAudio();
            this.detectVideo();
        }, 1000)
    }
    //去录制
    showModal = () => {
        if(this.state.checkAllPassed){
            this.setState({
                visible: true
            })
        }      
    }
    //试录
    toTry = () => {
        this.props.history.replace({
            pathname: "/record",
            search: "?accountId="+ this.state.accountId + "&lang=" + this.state.lang +"&questionIndex=-1&showPosture=1"
        })
    }
    //正式录制
    toRecord = () => {
        this.props.history.replace({
            pathname: "/record",
            search: "?accountId="+ this.state.accountId + "&lang=" + this.state.lang +"&questionIndex=0&showPosture=1"
        })
    }
    //浏览器检测
    detectBrowser = () => {
        const userAgent = navigator.userAgent;
        const isChrome = userAgent.match(/Chrome\/\d+/g) || [];
        const chromeVersion = isChrome[0] ? parseInt(isChrome[0].split("/")[1]) : 0;
        const isFirefox = userAgent.match(/Firefox\/\d+/g) || [];
        const firefoxVersion = isFirefox[0] ? parseInt(isFirefox[0].split("/")[1]) : 0;
        const isSafari = userAgent.indexOf("Macintosh") >= 0 ? (userAgent.match(/Version\/\d+/g) || []) : [];
        const safariVersion = isSafari[0] ? parseInt(isSafari[0].split("/")[1]) : 0;
        if(chromeVersion >= 58 || firefoxVersion >= 56 || safariVersion >= 11){
            this.setState({
                browser: "passed"
            }, this.getCheckResult)
        }else{
            this.setState({
                browser: "failed"
            })
        }
    }
    //网络监测
    detectNetwork = () => {
        // agoraClient.getNetworkStats(network => {
            if(navigator.onLine){
                this.setState({
                    network: "passed"
                }, this.getCheckResult)
            }else{
                this.setState({
                    network: "failed"
                })
            }
        // })
    }
    // 麦克检测
    detectAudio = () => {
        // agoraClient.getRecordingDevices(devices => {
        //     clearTimeout(audioTimer);
        //     if(devices.length > 0){
        //         this.setState({
        //             audio: "passed"
        //         }, this.getCheckResult)
        //     }else{
        //         this.setState({
        //             audio: "failed"
        //         })
        //     }
        // })
        TRTC.getMicrophones()
        .then(microphoneList => {
            clearTimeout(audioTimer);
            if(microphoneList.length > 0){
                this.setState({
                    audio: "passed"
                }, this.getCheckResult)
            }else{
                this.setState({
                    audio: "failed"
                })
            }
        })
        // 5s获取不到设备信息，按失败处理
        const audioTimer = setTimeout(() => {
            this.setState({
                audio: "failed"
            })
        }, 5000)
    }
    // 摄像头检测
    detectVideo = () => {
        // agoraClient.getCameras(devices => {
        //     clearTimeout(videoTimer);
        //     if(devices.length > 0){
        //         this.setState({
        //             video: "passed"
        //         }, this.getCheckResult)
        //     }else{
        //         this.setState({
        //             video: "failed"
        //         })
        //     }
        // })
        TRTC.getCameras()
        .then(cameraList => {
            clearTimeout(videoTimer);
            if(cameraList.length > 0){
                this.setState({
                    video: "passed"
                }, this.getCheckResult)
            }else{
                this.setState({
                    video: "failed"
                })
            }
        })
        // 5s获取不到设备信息，按失败处理
        const videoTimer = setTimeout(() => {
            this.setState({
                video: "failed"
            })
        }, 5000)
    }

    getCheckResult = () => {
        const { browser, network, audio, video, i18n } = this.state;
        if(browser == "passed" && network == "passed" && audio == "passed" && video == "passed"){
            this.setState({
                checkAllPassed: true
            })
        }else{
            this.setState({
                checkAllPassed: false
            })
        }
    }

    render(){
        const { i18n, browser, network, audio, video, checkAllPassed } = this.state;
        //根据状态获取颜色
        const getClassByStatus = (status) => {
            if(status === "pending"){
                return "blue";
            }else if(status === "passed"){
                return "green";
            }else if(status === "failed"){
                return "red";
            }else{
                return "";
            }
        }
        
        // 国际化
        if(!i18n) return null;

        return(
            <div className="video-app-wrap video-background-wrap">
                <VideoHeader i18n={i18n}/>
                <div className="video-check-nav">
                    <img src={videoHome} />
                    <strong>{i18n.pageTitle.index}</strong>
                    <span> > </span>
                    <strong>{i18n.pageTitle.check}</strong>
                </div>
                <div className="video-main-wrap">
                    <div className="video-check-main">
                        <h3 className="video-check-main-tit">{i18n.check.title}</h3>
                        <p className="video-check-main-sure">{i18n.check.subtitle}</p>
                        <div className="video-check-main-items">
                            <div className={"video-check-main-item " + (browser === "pending"?"video-check-main-itemBorder":"")}>
                                <div className={"video-check-main-itemImg " + getClassByStatus(browser)}>
                                    <i className="iconfont icon-browser"></i>
                                </div>
                                <h3>{i18n.check.browser}</h3>
                                <p>{i18n.check.browserInfo}</p>
                                {
                                    browser === "pending"?
                                    <div className="video-check-main-items-msg">
                                        <img className="animate-rotate" src={videoPending}/>
                                        <span className="blue">{i18n.check.pendingStatus}</span>
                                    </div>:
                                    (browser === "passed"?
                                    <div className="video-check-main-items-msg">
                                        <img src={videoPassed}/>
                                        <span className="green">{i18n.check.passedStatus}</span>
                                    </div>:
                                    <div className="video-check-main-items-msg">
                                        <img src={videoFailed}/>
                                        <span className="red">{i18n.check.failedStatus}</span>
                                    </div>)
                                }
                            </div>
                            <div className={"video-check-main-item " + (network === "pending"?"video-check-main-itemBorder":"")}>
                                <div className={"video-check-main-itemImg " + getClassByStatus(network)}>
                                    <i className="iconfont icon-network"></i>
                                </div>
                                <h3>{i18n.check.network}</h3>
                                <p>{i18n.check.networkInfo}</p>
                                {
                                    network === "pending"?
                                    <div className="video-check-main-items-msg">
                                        <img className="animate-rotate" src={videoPending}/>
                                        <span className="blue">{i18n.check.pendingStatus}</span>
                                    </div>:
                                    (network === "passed"?
                                    <div className="video-check-main-items-msg">
                                        <img src={videoPassed}/>
                                        <span className="green">{i18n.check.passedStatus}</span>
                                    </div>:
                                    <div className="video-check-main-items-msg">
                                        <img src={videoFailed}/>
                                        <span className="red">{i18n.check.failedStatus}</span>
                                    </div>)
                                }
                            </div>
                            <div className={"video-check-main-item " + (audio === "pending"?"video-check-main-itemBorder":"")}>
                                <div className={"video-check-main-itemImg " + getClassByStatus(audio)}>
                                    <i className="iconfont icon-audio"></i>
                                </div>
                                <h3>{i18n.check.microphone}</h3>
                                <p>{i18n.check.microphoneInfo}</p>
                                {
                                    audio === "pending"?
                                    <div className="video-check-main-items-msg">
                                        <img className="animate-rotate" src={videoPending}/>
                                        <span className="blue">{i18n.check.pendingStatus}</span>
                                    </div>:
                                    (audio === "passed"?
                                    <div className="video-check-main-items-msg">
                                        <img src={videoPassed}/>
                                        <span className="green">{i18n.check.passedStatus}</span>
                                    </div>:
                                    <div className="video-check-main-items-msg">
                                        <img src={videoFailed}/>
                                        <span className="red">{i18n.check.failedStatus}</span>
                                    </div>)
                                }
                            </div>
                            <div className={"video-check-main-item " + (video === "pending"?"video-check-main-itemBorder":"")}>
                                <div className={"video-check-main-itemImg " + getClassByStatus(video)}>
                                    <i className="iconfont icon-video"></i>
                                </div>
                                <h3>{i18n.check.camera}</h3>
                                <p>{i18n.check.cameraInfo}</p>
                                {
                                    video === "pending"?
                                    <div className="video-check-main-items-msg">
                                        <img className="animate-rotate" src={videoPending}/>
                                        <span className="blue">{i18n.check.pendingStatus}</span>
                                    </div>:
                                    (video === "passed"?
                                    <div className="video-check-main-items-msg">
                                        <img src={videoPassed}/>
                                        <span className="green">{i18n.check.passedStatus}</span>
                                    </div>:
                                    <div className="video-check-main-items-msg">
                                        <img src={videoFailed}/>
                                        <span className="red">{i18n.check.failedStatus}</span>
                                    </div>)
                                }
                            </div>
                        </div>
                        <button className={"video-check-main-begin " + (checkAllPassed ? "passed" : "disabled") }
                            onClick={this.showModal}>{i18n.check.btnText}</button>
                    </div>
                </div>
                <VideoModel visible={this.state.visible} title={i18n.startInterviewModal.title}>
                    <div className="model-record-wrap">
                        <img className="model-record-img" src={startRecord} />
                        <p className="model-record-content">{i18n.startInterviewModal.content1}</p>
                        <p className="model-record-content">{i18n.startInterviewModal.content2}</p>
                        <div className="model-record-btns">
                            <div className="model-record-btn model-btn-fill" onClick={this.toTry}>{i18n.startInterviewModal.cancelText}</div>
                            <div className="model-record-btn model-btn-blank" onClick={this.toRecord}>{i18n.startInterviewModal.okText}</div>
                        </div>
                    </div>
                </VideoModel>
                <VideoFooter i18n={i18n}/>
            </div>
        )
    }
}

export default App;